
import { toast } from "@/hooks/use-toast";
import { InterfaithResponse } from "../types";
import { shareViaEmail as baseSocialShareViaEmail, shareViaSMS as baseSocialShareViaSMS, shareToFacebook as baseSocialShareToFacebook } from "@/utils/socialShareUtils";

export const shareViaEmail = (selectedFaith: string | null, question: string, response: InterfaithResponse | null) => {
  if (!response) return;
  
  const subject = `Interfaith Dialogue: ${selectedFaith} - ${question}`;
  const body = `
I wanted to share this biblical response about ${selectedFaith} with you:

Question: ${question}

Direct Answer:
${response.directAnswer}

Biblical Foundation:
${response.biblicalFoundation}

~ Shared from Selah
  `;
  
  // Use the base utility function
  baseSocialShareViaEmail(subject, body);
};

export const shareViaSMS = (selectedFaith: string | null, question: string, response: InterfaithResponse | null) => {
  if (!response) return;
  
  const text = `
Interfaith Dialogue: ${selectedFaith} - ${question}

Direct Answer:
${response.directAnswer}

~ Shared from Selah
  `;
  
  // Use the base utility function
  baseSocialShareViaSMS(text);
};

export const shareToFacebook = () => {
  // Use the base utility function with cache busting
  baseSocialShareToFacebook();
  
  toast({
    title: "Sharing to Facebook",
    description: "A Facebook share dialog should have opened.",
  });
};
